import React from 'react';
import { faq as faqUrl } from '../../helpers/routes';
import { mailTo, customerCareEmail } from '../../helpers/emailAddresses';
import { Wrapper } from '../../components_desktop/css_global/utils.css';
import withCountryCode from '../../components/RoutesHoc/RoutesHoc';

const ReviewsOrderProcessing = ({ buildUrlWithCountry }) => (
  <div>
    <Wrapper font={'"Avenir Light", "Arial", sans-serif'} fontSize="13px" padding="15px">
      <p>EVERY PURCHASE INCLUDES EXPRESS SHIPPING, SO YOUR PRODUCT(S) WILL ARRIVE WITHIN 2 – 4 BUSINESS DAYS.</p>
      <p>
        ALL RETURNS MUST BE SHIPPED TO ITALIST WITHIN 14 DAYS OF THE PACKAGE DELIVERY DATE. PLEASE BE SURE TO READ OUR
        RETURN POLICY THOROUGHLY BEFORE REQUESTING A RETURN.
      </p>
      <p>
        QUESTIONS? CONTACT US AT
        <a href={mailTo(customerCareEmail)} style={{ textDecoration: 'underline' }}>
          CUSTOMERCARE@ITALIST.COM
        </a>
        OR BROWSE OUR
        <a href={buildUrlWithCountry(faqUrl)} style={{ textDecoration: 'underline' }}>
          FAQ
        </a>
        PAGE.
      </p>
    </Wrapper>
  </div>
);

export default withCountryCode(ReviewsOrderProcessing);
